import React from 'react';

import Icon from '@ant-design/icons/lib/components/Icon';

import { ReactComponent as StarIcon } from '../../../../../assets/sightx-icons/svg/sx-star-plus.svg';
import { SxTrialModal } from '../../../../common/SxTrialModal';
import { Features, isFeatureEnabled } from '../../../../../featureToggles/features';
import { ProTrialRightSection } from './ProTrialRightSection';
import { ProTrialContent } from './ProTrialContent';

import styles from './index.module.scss';

interface IProTrialConfirmationModal {
  onClose: () => void;
}

export const ProTrialConfirmationModal: React.FunctionComponent<IProTrialConfirmationModal> = ({ onClose }) => {
  const renderHeader = () => {
    return (
      <div className={styles.header}>
        Try out SightX Professional&nbsp;<b>for free</b>&nbsp; <Icon component={StarIcon}/>
      </div>
    );
  };
  const renderLeftSection = () => <ProTrialContent onCancel={onClose} onClose={onClose} />;
  const renderRightSection = () => <ProTrialRightSection/>;

  if (!isFeatureEnabled(Features.TrialsOfTiers)) {
    return null;
  }

  return (
    <SxTrialModal
      showCloseIcon
      header={renderHeader()}
      leftSection={renderLeftSection()}
      rightSection={renderRightSection()}
      onClose={onClose}
    />
  );
};